import React, { useMemo, useState } from 'react';

import Loader from 'components/uiLibrary/Loader';

import useTracking from 'components/Globals/Analytics';
import { SUB_COMPONENTS } from 'components/Globals/Analytics/constants';

import { useDialogs } from 'utils/hooks/useDialogs';
import { transformProductionDataToConciseData } from 'utils/productions';
import { useQuery } from 'utils/react-query';

import queries from 'containers/Productions/queries';

import ExpandedView from './ExpandedView';
// eslint-disable-next-line import/no-cycle
import ProductionSlugInline from './ProductionSlugInline';
import ProSlugCollapsed from './ProSlugCollapsed';

const ProductionProSlug = ({
  production,
  entity,
  showWorkDetails,
  trackingData = {},
  isCastingSlug,
  inline,
  entityType,
  showExpandedSlug,
  handleRoleSelect,
  isJumpInSlug,
  selectedWorkId,
}) => {
  const track = useTracking();
  const [isExpandedOnce, setIsExpandedOnce] = useState(false);
  const { isJumpInSelectProductionsModalOpen } = useDialogs();

  const { data: productionDetails } = useQuery(
    queries.getProductionDetails({
      id: production?.id,
      queryConfig: { enabled: isExpandedOnce && !!production?.id && isCastingSlug },
    }),
  );

  const conciseProduction = useMemo(
    () =>
      isCastingSlug
        ? production
        : transformProductionDataToConciseData({
            production,
            entity,
            entityType,
            isJumpInModal: isJumpInSelectProductionsModalOpen,
          }),
    [isCastingSlug, production, entity, entityType, isJumpInSelectProductionsModalOpen],
  );

  const handleExpand = () => {
    setIsExpandedOnce(false);
    track.click({
      ...trackingData,
      subComponent: SUB_COMPONENTS.EXPANDED,
      meta: {
        isOpen: true,
      },
    });
  };

  const productionData = isCastingSlug ? productionDetails : production;

  if ((isExpandedOnce && productionData?.id) || showExpandedSlug) {
    return (
      <ExpandedView
        entityType={entityType}
        production={productionData}
        entity={entity}
        showWorkDetails={showWorkDetails}
        openInNewTab
        trackingData={{ subComponent: SUB_COMPONENTS.EXPANDED, ...trackingData }}
        onClick={handleExpand}
        inline={inline}
        isExpanded
        showExpandedSlug={showExpandedSlug}
        handleRoleSelect={handleRoleSelect}
        isJumpInSlug={isJumpInSlug}
        selectedWorkId={selectedWorkId}
      />
    );
  }

  if (inline) {
    return (
      <>
        <ProductionSlugInline
          entityType={entityType}
          production={conciseProduction}
          onClick={() => setIsExpandedOnce(true)}
          entityId={entity?.id}
          showWorkDetails={showWorkDetails}
          trackingData={{ subComponent: SUB_COMPONENTS.COLLAPSED, ...trackingData }}
          entity={entity}
        />
        {isExpandedOnce && !productionDetails?.id && <Loader small />}
      </>
    );
  }

  return (
    <>
      <ProSlugCollapsed
        entityType={entityType}
        conciseProduction={conciseProduction}
        onClick={() => setIsExpandedOnce(true)}
        entityId={entity?.id}
        showWorkDetails={showWorkDetails}
        trackingData={{ subComponent: SUB_COMPONENTS.COLLAPSED, ...trackingData }}
        isJumpInSlug={isJumpInSlug}
        selectedWorkId={selectedWorkId}
        handleRoleSelect={handleRoleSelect}
        entity={entity}
      />
      {isExpandedOnce && !productionDetails?.id && <Loader small />}
    </>
  );
};

export default ProductionProSlug;
